<template>
  <div class="modal" :class="[$realmNameId==50?'modal-50':'']">
    <div class="modal-cover"></div>
    <div :class="['modalOff','modalOff'+modalClass]" :style="(modalClass==3?leftCss:'')"></div>
    <template v-if="modalOff==0">
      <div class="icon-guide" :class="['icon-guide'+modalClass]">
        <span class="icon-guide icon-know" :class="['icon-know'+modalClass]" @click="startStep"></span>
        <span class="icon-guide icon-know icon-bye" @click="closeTips"></span>
      </div>
    </template>
    <template v-else>
      <div class="icon-guide" :class="['icon-guide'+modalClass]" :style="modalClass==3?leftCss:''">
        <span class="icon-guide icon-know" :class="['icon-know'+modalClass]" @click="nextStep"></span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['state', 'client'], // 0:home/index.vue  1:searchPage/index.vue  2:city/index.vue 3:map/index.vue
  name: 'Modal',
  data () {
    return {
      modalOff: 0,
      n: 3,
      modalOffAll: 3,
      modalClass: 0,
      leftCss: {}
    }
  },
  created () {
    $('body,html').animate({scrollTop: 0}, 500);
    $('body').css('overflow-y', 'hidden')
  },
  mounted () {
  },
  components: {},
  methods: {
    startStep: function () {
      this.stateFun()
    },
    stateFun: function () {
      let that = this
      if (that.state === 1) {
      } else if (that.state === 2) {
        let stateBool0 = that.publicJs.getCookie(0)
        if (!stateBool0) {
          that.modalOff = 1
          this.modalClass = that.modalOff
        } else {
          that.modalOff = 3
          that.modalClass = '2-3'
        }
      } else if (that.state === 3) {

      } else {
        that.modalOff = 1
        that.modalOffAll = 3
        this.modalClass = that.modalOff
      }
    },
    nextStep: function () {
      let that = this
      if (that.modalOff < that.modalOffAll) {
        that.modalOff++
        that.modalClass = that.state > 0 && that.modalOff === 3 ? that.state + '-' + that.modalOff : that.modalOff
        if (that.state === 0 && that.modalOff === 3) {
          $('body,html').animate({scrollTop: 180}, 500)
        } else {
          $('body,html').animate({scrollTop: 0}, 500)
        }
      } else {
        $('body').css('overflow-y', 'auto')
        that.$emit('modalBool', false)
        that.publicJs.setCookie(0, 'true', 60)
      }
    },
    closeTips: function () {
      $('body').css('overflow-y', 'auto')
      this.$emit('modalBool', false)
      this.publicJs.setCookie(0, 'true', 60)
    }
  },
  watch: {
    modalClass: {
      handler: function (a, b) {
        if (a !== b) {
          let that = this
          if (a === 3) {
            let el = $('.slide-address1')
            let l = el.offset().left
            let w = el.width()
            that.leftCss = {
              left: (l - w / 2 - 10) + 'px'
            }
          } else {
            that.leftCss = {}
          }
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal{}
  .modal-cover{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .modalOff{
    position: absolute;
    -webkit-box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    -moz-box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    z-index: 110;
  }
  .modalOff0{
    position: absolute;
    right: 50%;
    top: 50%;
    width: 0;
    height:0;
  }
  .modalOff1{
    position: fixed;
    right: 30px;
    top: 4px;
    width: 145px;
    height: 55px;
    border-radius: 8px;
  }
  .modalOff2{
    right: 52px;
    top: 94px;
    width: 62px;
    height: 62px;
    border-radius: 50%;
  }
  .modalOff3{
    left: 51.5%;
    top: 656px;
    width: 124px;
    height: 50px;
    border: 1px solid #FFFFFF;
    border-radius: 10px;
  }
  .modalOff2-3{
    position: fixed;
    right: 208px;
    top: 7px;
    width: 120px;
    height: 49px;
    border-radius: 8px;
  }
  .modal-four{
    position: absolute;
  }
  .icon-guide{
    position: absolute;
    z-index: 111;
  }
  .icon-guide0{
    position: fixed;
    top:50%;
    right: 50%;
    margin-top: -140px;
    margin-right: -235px;
    width: 470px;
    height: 280px;
    background-position:-182px -295px;
  }
  .modalOff0,
  .modalOff1,
  .modalOff2,
  .modalOff2-3,
  .modal .icon-guide1,
  .modal .icon-guide2,
  .modal .icon-guide2-3{
    -webkit-transition: right 0.8s,top 0.8s;
    -moz-transition: right 0.8s,top 0.8s;
    -ms-transition: right 0.8s,top 0.8s;
    -o-transition: right 0.8s,top 0.8s;
    transition: right 0.8s,top 0.8s;
  }

  .modalOff3,
  .modal .icon-guide3{
    -webkit-transition: width 0.8s,top 0.8s;
    -moz-transition: width 0.8s,top 0.8s;
    -ms-transition: width 0.8s,top 0.8s;
    -o-transition: width 0.8s,top 0.8s;
    transition: width 0.8s,top 0.8s;
  }
  .icon-guide1{
    top:3px;
    right: 25px;
    width: 365px;
    height: 330px;
    background-position:-788px -102px;
    position: fixed;
  }
  .icon-guide2{
    width: 524px;
    height: 411px;
    top: 73px;
    right: 41px;
    background-position: -231px -555px;
  }
  .icon-guide3{
    width: 412px;
    height: 210px;
    top: 587px;
    right: 36.4%;
    background-position: -1365px -129px;
  }
  .icon-guide2-3{
    top: 3px;
    right: 132px;
    width: 299px;
    height: 300px;
    background-position: -1269px -553px;
    position: fixed;
  }
  .icon-know{
    width: 110px;
    height: 46px;
    background-position: -262px -1165px;
  }
  .icon-know0{
    right:271px;
    bottom: 0;
    background-position: -437px -1165px;
  }
  .icon-bye{
    right:96px;
    bottom: 0;
    background-position: -617px -1159px;
  }
  .icon-know1{
    right:161px;
    bottom: 0;
  }
  .icon-know2{
    top: 390px;
    right: 350px;
  }
  .icon-know3{
    top: 91px;
    right: -13px;
  }
  .icon-know2-3{
    right:161px;
    bottom: 0;
  }
  .screen2 .modalOff1{
    right: 13px;
  }
  .screen2 .icon-guide1{
    right: 9px;
  }
  .screen2 .modalOff2-3{
    right: 165px;
  }
  .screen2 .icon-guide2-3{
    right: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue